import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Space } from 'antd';
import { txt } from 'libs/i18n';
import { LockOutlined } from '@ant-design/icons';
import ChangePasswordForm from '../ChangePasswordForm';
import styles from './style.module.less';
import ApiToken from '../ApiToken';
const Authentification = ({ canChangePassword, canSeeApiToken }) => {
    return (_jsxs(_Fragment, { children: [_jsxs(Space, { className: styles.authentification, children: [_jsx(LockOutlined, {}), txt('authentification')] }), canChangePassword && (_jsx(ChangePasswordForm, {})), canSeeApiToken && (_jsx(ApiToken, {}))] }));
};
export default Authentification;
